module.exports = __webpack_public_path__ + "img/burner-mining-drill-S.c0429e47.png";